module.exports = __webpack_public_path__ + "static/media/close_truck_image.a43d2e1c.png";